import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  OutlinedInput,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { Divider } from "@mui/material";

const dividerStyle = {
  py: 0,
  my: "2px !important",
  width: '80%',
  maxWidth: 360,
  borderRadius: 2,
  border: '0.1px solid var(--app-border)',
  borderColor: 'divider',
};
const DropdownIcon = (props) => (
  <Icon
    icon="eva:arrow-ios-downward-fill"
    width={18}
    height={18}
    {...props}
  />
);

function RolesFilter({ value = [], onChange, component }) {
  const count = value.length;
  return (
    <FormControl size="small">
      <Select
        multiple
        value={value}
        onChange={(e) => onChange(e.target.value)}
        IconComponent={DropdownIcon}
        input={<OutlinedInput />}
        displayEmpty
        renderValue={() => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            <span>Role</span>

            {count > 0 && (
              <Box
                sx={{
                  minWidth: 18,
                  height: 18,
                  borderRadius: "50%",
                  backgroundColor: "#6C63FF",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {count}
              </Box>
            )}
          </Box>
        )}
        sx={{
          height: 38,
          minWidth: 80,
          borderRadius: "10px",
          backgroundColor: component === "members" ? "var(--app-surface)" : "var(--app-surface)",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1,
              borderRadius: "10px",
              border: "1px solid var(--app-border)",
              boxShadow: "var(--app-shadow)",
              width:"140px"
            },
          },
          disableScrollLock: true,
        }}
      >

        
        <MenuItem value="b2b-admin" sx={{
          py: 0,
          "&.Mui-selected": {
            backgroundColor: "transparent",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "transparent",
          },
        }}>
          <Checkbox
            checked={value.includes("b2b-admin")}
            size="small"
            sx={{
              color: "var(--app-border)",
                "&.Mui-checked": {
      color: "#5751E9", //  checked color
    },
              "& .MuiSvgIcon-root": {
                borderRadius: "8px",
                fontSize: 20,
              },
            }}
          />
          <ListItemText
            primary="Admin"
            primaryTypographyProps={{ fontSize: "14px", color: "var(--app-text)", fontWeight: 500 }}
          />
        </MenuItem>
        <Divider variant="middle" component="li" sx={dividerStyle} />

        <MenuItem value="b2b-member" sx={{
          py: 0,
          "&.Mui-selected": {
            backgroundColor: "transparent",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "transparent",
          },
        }}>
          <Checkbox
            checked={value.includes("b2b-member")}
            size="small"
            sx={{
              color: "var(--app-border)",
                "&.Mui-checked": {
      color: "#5751E9", //  checked color
    },
              "& .MuiSvgIcon-root": {
                borderRadius: "8px",
                fontSize: 20,
              },
            }}
          />
          <ListItemText
            primary="Member"
            primaryTypographyProps={{ fontSize: "14px", color: "var(--app-text)", fontWeight: 500 }}
          />
        </MenuItem>
         <Divider variant="middle" component="li" sx={dividerStyle} />

        <MenuItem value="b2b-doctor" sx={{
          py: 0,
          "&.Mui-selected": {
            backgroundColor: "transparent",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "transparent",
          },
        }}>
          <Checkbox
            checked={value.includes("b2b-doctor")}
            size="small"
            sx={{
              color: "var(--app-border)",
                "&.Mui-checked": {
      color: "#5751E9", //  checked color
    },
              "& .MuiSvgIcon-root": {
                borderRadius: "8px",
                fontSize: 20,
              },
            }}
          />
          <ListItemText
            primary="Doctor"
            primaryTypographyProps={{ fontSize: "14px", color: "var(--app-text)", fontWeight: 500 }}
          />
        </MenuItem>
        <Divider variant="middle" component="li" sx={dividerStyle} />

        <MenuItem value="b2b-viewer" sx={{
          py: 0,
          "&.Mui-selected": {
            backgroundColor: "transparent",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "transparent",
          },
        }}>
          <Checkbox
            checked={value.includes("b2b-viewer")}
            size="small"
            sx={{
              color: "var(--app-border)",
                "&.Mui-checked": {
      color: "#5751E9", //  checked color
    },
              "& .MuiSvgIcon-root": {
                borderRadius: "8px",
                fontSize: 20,
              },
            }}
          />
          <ListItemText
            primary="Viewer"
            primaryTypographyProps={{ fontSize: "14px", color: "var(--app-text)", fontWeight: 500 }}
          />
        </MenuItem>
       

      </Select>
    </FormControl>)
    
}

export default RolesFilter;
